import styled from "@emotion/styled";
import { TransitionalCTA } from "@italymondo/core-ui";

export const StyledTransitionalCTA = styled(TransitionalCTA)`
  padding-top: 0 !important;
`;
